var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTailMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DFD8FF",
  d: "M.027 3.497c.849 0 2.667.43 4.656.901 2.926.693 6.222 1.472 7.344 1.1-4-3-2.19-4.117-.674-5.195C8.333 2.159 4.26 3.24.027 3.497"
})));
export default SvgTailMessage;